import { EventListener } from "./eventVerteiler";
import { CookieConsentHandler } from "./cookieconsent/cookieHandler";
import { CookieHandler } from "./cookieconsent/cookieHandler";
import { logIfDebug } from "./logFunctions";

declare const gtag, fbq;

/**
 * @classdesc Eine Klasse, die eine URL entgegen nimmt und dann ein Google Tracking absetzt
 * @class
 * @param {string}      domain        Die Domain auf der wir tracken wollen
 * @param {string}      sport
 * @param {string}      produkt
 *
 */
export class GoogleTracker extends EventListener {
    private eventIgnoreListRegexStrings: any[];
    private ignorelistLoaded: boolean;
    private domain:string;
    private readonly sport:string;
    private readonly produkt:string;
    private readonly konfi:string;
    private land:string;
    private url:string;
    private readonly isTrackable: boolean;
    private pageTracker: any;
    private getEmailFromActiveUser: any;
    public static TRACKERID:string;

    constructor(domain, sport, produkt, konfi, land, getEmailFromActiveUser) {
        super();
        this.eventIgnoreListRegexStrings = [];
        this.ignorelistLoaded = false;
        this.domain = domain;
        this.sport = sport;
        this.produkt = produkt;
        this.konfi = konfi;
        this.land = land;
        this.url = "";
        /** isTrackable tracken wir die domain?*/
        this.isTrackable = true;
        /** pageTracker - ID(?) / Kennung des Trackers*/
        this.pageTracker = null;
        this.loadEventIgnoreList();
        this.getEmailFromActiveUser = getEmailFromActiveUser;
        this.addEventListener("CookieConsentChoiceMadeEvent", () => {
            if (CookieConsentHandler.analyticCookiesAllowed()) {
                console.log('Choice Made 1');
                this.consentGrantedStatistics();
            }
            if (CookieConsentHandler.marketingCookiesAllowed()) {
                console.log('Choice Made 2');
                this.consentGranted();
            } else {
                CookieHandler.deleteGoogleCookies();
            }
        });
    }
    consentGrantedStatistics() {
        gtag('consent', 'update', {
            'analytics_storage': 'granted'
        });
    }
    consentGranted() {
        gtag('consent', 'update', {
            'ad_storage': 'granted',
            'ad_personalization': 'granted',
            'ad_user_data': 'granted'
        });

        if ( (window as any).fbq && typeof  (window as any).fbq === 'function') {
            fbq('consent', 'grant');
        }
        (window as any).uetq = (window as any).uetq || [];
        (window as any).uetq.push('consent', 'update', {'ad_storage': 'granted'});
    }

    /**
     * Pageview (URL) tracken
     */
    async trackPageview(url) {
        // if (this.matchesIgnoredEvent(url)) {
        //     return;
        // }
        // try {
        //     if (this.isTrackable) {
        //         if (typeof (url) !== "undefined") {
        //             const product = (this.produkt === "" || this.produkt === undefined) ? "radtrikots" : this.produkt;
        //             const sport = (this.sport === "" || this.sport === undefined) ? "radsport" : this.sport;
        //             url = sport + "-" + product + "/" + url;
        //             if (this.konfi != "") {
        //                 url = url + "?konfi=" + this.konfi;
        //             }
        //             // let email = await hashStringSHA256(this.getEmailFromActiveUser());
        //             // if(email!=="") {
        //             //     // alert(email);
        //             //     gtag('set', 'user_data', {
        //             //         'sha256_email_address': email
        //             //     });
        //             // }
        //             // gtag('event', 'page_view', {
        //             //     'page_title': GoogleTracker.prependProtocolAndHost(url),
        //             //     'page_location': GoogleTracker.prependProtocolAndHost(url)
        //             // });
        //             // fbq('track', 'PageView', {
        //             //     page_url: GoogleTracker.prependProtocolAndHost(url)
        //             // });
        //             console.log("sent " + GoogleTracker.prependProtocolAndHost(url));
        //
        //         }
        //     }
        //     else {
        //         console.log("not trackable");
        //         // logIfDebug("not trackable");
        //     }
        // }
        // catch (e) {
        //     console.log("exception happened");
        //     // do nothing;
        // }
    }
    static prependProtocolAndHost(url) {
        return window.location.protocol + "//" + window.location.host + "/" + url;
    }
    // noinspection JSUnusedGlobalSymbols
    async trackEvent(eventName, params) {
        // try {
        //     if (this.isTrackable) {
        //         // const hashedEmail = await hashStringSHA256(this.getEmailFromActiveUser());
        //         //
        //         // if(hashedEmail!=="") {
        //         //     gtag('set', 'user_data', {
        //         //         'sha256_email_address': hashedEmail
        //         //     });
        //         // }
        //         // gtag('event', eventName, params);
        //     }
        //     else {
        //         logIfDebug("not trackable");
        //     }
        // }
        // catch (e) {
        //     // do nothing;
        // }
    }
    trackFbq(eventName, params = null) {
        // if (typeof (fbq) !== "function") {
        //     return;
        // }
        // try {
        //     if (this.isTrackable) {
        //         // fbq('track', eventName, params);
        //     }
        //     else {
        //         logIfDebug("not trackable");
        //     }
        // }
        // catch (e) {
        //     // do nothing;
        // }
    }
    trackBingEvent(eventName, params = null) {
        // try {
        //     if (this.isTrackable) {
        //         (window as any).uetq = (window as any).uetq || [];
        //         (window as any).uetq.push('event', eventName, params);
        //     }
        //     else {
        //         logIfDebug("not trackable");
        //     }
        // }
        // catch (e) {
        //     console.log("Bing Tracker threw: ");
        // }
    }

    loadEventIgnoreList() {
        fetch("/konfigurator_php/tracking/trackingignorelist.php?land=" + this.land).then(response => response.json().then(ignorelist => {
            this.ignorelistLoaded = true;
            this.eventIgnoreListRegexStrings = ignorelist;
        }));
    }
    matchesIgnoredEvent(url) {
        return this.eventIgnoreListRegexStrings.reduce((carry, regexstring) => {
            return carry || new RegExp(regexstring).exec(url) !== null;
        }, false);
    }
}
GoogleTracker.TRACKERID = 'AW-1072577248';
